export default __webpack_public_path__ + "static/media/51.55a9dfff.png";